function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import capFirstLetter from '../../helpers/capFirstLetter';
import Table from '../common/table/Table.react';
import Input from '../common/form/Input.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import PopupsAdd from './PopupsAdd.modal';

// TODO :: Stop if app / type is not in constants
var PopupsTable = function PopupsTable(_ref) {
  var _ref$popupArr = _ref.popupArr,
    popupArr = _ref$popupArr === void 0 ? [] : _ref$popupArr,
    app = _ref.app,
    addModalAction = _ref.addModalAction;
  var navigate = useNavigate();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    tableData = _useState2[0],
    setTableData = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    filter = _useState4[0],
    setFilter = _useState4[1];
  useEffect(function () {
    var data = [];
    popupArr.forEach(function (x) {
      if (!x.archived) data.push({
        name: x.name,
        _id: x._id
      });
    });
    setTableData({
      columns: {
        id: {
          title: '_id',
          visible: false
        },
        name: 'Name'
      },
      data: data
    });
  }, [popupArr]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "".concat(capFirstLetter(app), " Popups"),
    button: {
      label: 'New Popup',
      type: 'add',
      permission: 'edit-pos-popup',
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(PopupsAdd, {
            app: app
          })
        });
      }
    }
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Input, {
    value: filter,
    onChange: function onChange(e) {
      return setFilter(e.target.value);
    },
    placeholder: "Filter..."
  })), /*#__PURE__*/React.createElement(Table, _extends({}, tableData, {
    filter: filter,
    filterColumns: ['name'],
    tr: {
      onClick: function onClick(row) {
        return navigate("/popup/".concat(row._id));
      }
    },
    sort: {
      by: 'name'
    }
  }))));
};
var mdtp = {
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(PopupsTable);